import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { ResponsiveBox } from 'src/app/pages/petitionDetails/shared/components';

import { PetitionUrlQRCode } from '../QRCode';

import { ShareLoader } from './ShareLoader';

export const SharePetition: React.FC = () => {
	return (
		<Box px={[16, 0]} data-qa="share-section">
			<Heading as="h2" size={['h3']} mb={16}>
				<Translate value="corgi.petition_gamma.share.title" />
			</Heading>
			<Box
				sx={{
					gap: 16,
					display: 'flex',
					flexDirection: ['column', 'row'],
				}}
			>
				{/* PetitionUrlQRCode is client-only because it checks the user-agent (for share channels), which is not available in SSR */}
				<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
					<PetitionUrlQRCode />
				</ClientRender>
				<Box
					sx={{
						width: '100%',
					}}
				>
					<ResponsiveBox viewportSize="small">
						<ShareLoader forMobileView />
					</ResponsiveBox>
					<ResponsiveBox viewportSize="normal">
						<ShareLoader forMobileView={false} />
					</ResponsiveBox>
				</Box>
			</Box>
		</Box>
	);
};
